export default __webpack_public_path__ + "dist/media/Attachment.eeae66e4.svg";